import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services';
import { useSiteSettings } from '../context/SiteSettingsContext';

function Navbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isAuthenticated = authService.isAuthenticated();
  const user = authService.getCurrentUser();
  const isAdmin = user?.role === 'admin';
  const { siteSettings, loading } = useSiteSettings();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-header">
          <Link to="/" className="navbar-brand" onClick={closeMenu}>
            <span className="navbar-site-title">{loading ? '' : siteSettings.siteTitle}</span>
          </Link>
          
          <div className="menu-icon" onClick={toggleMenu}>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
          </div>
        </div>

        <ul className={isMenuOpen ? 'navbar-links active' : 'navbar-links'}>
          {isAuthenticated && user && (
            <>
              {isAdmin && <li><Link to="/admin/site-config" onClick={closeMenu}>网站配置</Link></li>}
              {isAdmin && <li><Link to="/admin/permissions" onClick={closeMenu}>权限管理</Link></li>}
              <li>
                <button onClick={handleLogout} className="btn btn-outline">
                  退出登录
                </button>
              </li>
            </>
          )}
          {!isAuthenticated && (
            <>
              <li><Link to="/login" onClick={closeMenu}>登录</Link></li>
              <li><Link to="/register" onClick={closeMenu}>注册</Link></li>
            </>
          )}
        </ul>

        {isMenuOpen && (
          <div className="navbar-overlay" onClick={closeMenu}></div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
